import React, { JSX, useEffect } from 'react';
// import '../Accessibility/Accessibility';
import './Accessibility.scss';
// import { InvertColors } from '@mui/icons-material';
// import { closeMain, highlightLinks, increaseAndReset, resetAll, toggleCursorFeature, toggleFontFeature, toggleImages } from '../Accessibility/Accessibility';

interface FontSizeParams {
  btnId: string;
  featureItemId: string;
  featureStepsId: string;
  tickIconId: string;
  increase: boolean;
  btn: string;
}


function Accessibility(): JSX.Element {
  useEffect(() => {
    const widgetCustomTrigger = document.getElementById("uw-widget-custom-trigger");

    if (widgetCustomTrigger) {
      const handleClick = () => {
        openMain(); // Make sure `openMain` is defined in scope or imported
      };

      widgetCustomTrigger.addEventListener("click", handleClick);

      // Cleanup function to remove the event listener
      return () => {
        widgetCustomTrigger.removeEventListener("click", handleClick);
      };
    }
  }, []);

  function openMain() {
    var mainElement = document.getElementById('uw-main');
    if (mainElement) {
      mainElement.style.right = '0px';
    }
  }
  function closeMain() {
    var mainElement = document.getElementById('uw-main');
    if (mainElement) {
      mainElement.style.right = '-490px';
    } else {
      console.warn("Element with id 'uw-main' not found");
    }

  }
  // ****************************************** Font size increase Decrease ***********************************************
  // ****************************************** Font size increase Decrease ***********************************************
  const handleFontSizes = ({
    btnId,
    featureItemId,
    featureStepsId,
    tickIconId,
    increase,
    btn,
  }: {
    btnId: string;
    featureItemId: string;
    featureStepsId: string;
    tickIconId: string;
    increase: boolean;
    btn: string;
  }) => {
    var Storageclick = `${btn}-clickCount`;
    var ButtonStorageClick = `${btn}-buttonClicked`;
    var SizeStorage = `${btn}-size`;
    var clickCount = 0;
    var addsize = 0;

    // Check local storage for previous state
    var localStorageClickCount = localStorage.getItem(Storageclick);
    if (localStorageClickCount) {
      clickCount = parseInt(localStorageClickCount, 10);
    }

    clickCount++;
    addsize += 1;
    var featureItem = document.getElementById('featureItem');
    var featureSteps = document.getElementById('featureSteps');
    var tickIcon = document.getElementById('tickIcon');

    if (btnId == "btn-s9") {
      const btnSmallText = document.getElementById('btn-small-text') as HTMLButtonElement;
      if (btnSmallText) {
        btnSmallText.disabled = true;
      }
      localStorage.setItem('btn-big', 'true');
    }

    if (btnId == "btn-small-text") {
      const btn_small = document.getElementById('btn-s9') as HTMLButtonElement;
      if (btn_small) {
        btn_small.disabled = true;
      }
      localStorage.setItem('btn-small', JSON.stringify(true));
    }

    // Save current state to local storage
    localStorage.setItem(Storageclick, clickCount.toString());
    localStorage.setItem(ButtonStorageClick, JSON.stringify(true));


    // Reset on 5th click
    if (clickCount === 5) {
      clickCount = 0;
      addsize = 0;
      if (featureItem && featureSteps && tickIcon) {
        featureItem.classList.remove('feature-active');
        featureSteps.classList.remove('featureSteps-visible');
        featureSteps.innerHTML = '';
        tickIcon.style.display = 'none';
      }
      localStorage.setItem(Storageclick, JSON.stringify(0));
      localStorage.setItem(ButtonStorageClick, JSON.stringify(false));

      if (btnId == "btn-s9") {
        const btn_small_text = document.getElementById('btn-small-text') as HTMLButtonElement;
        if (btn_small_text) {
          btn_small_text.disabled = false;
        }
        localStorage.setItem('btn-big', JSON.stringify(false));
      }
      if (btnId == "btn-small-text") {
        const btn_s9 = document.getElementById('btn-s9') as HTMLButtonElement;
        if (btn_s9) {
          var otherBtn = btn_s9.disabled = false;
        }
        localStorage.setItem('btn-small', JSON.stringify(false));
      }

      // Reset font size of all elements
      resetFontSizes(btn, Storageclick, ButtonStorageClick);
      return;
    }
    // Add feature-active class on the first click
    if (clickCount === 1 && featureItem && featureSteps) {
      featureItem.classList.add('feature-active');
      featureSteps.classList.add('featureSteps-visible');
      localStorage.setItem(Storageclick, clickCount.toString());
      localStorage.setItem(ButtonStorageClick, JSON.stringify(true));
    }

    // Update data-uw-reader-content attribute
    const buttonElement = document.getElementById('btn-s9') as HTMLButtonElement;

    if (buttonElement) {
      buttonElement.setAttribute('data-uw-reader-content', clickCount.toString());
    } else {
      console.error('Button element not found');
    }

    // Add step span tags dynamically
    var stepsHTML = '';
    for (var i = 0; i < 4; i++) {
      stepsHTML += '<span class="' + (i < clickCount ? 'active step uwaw-features__step' : 'step uwaw-features__step') + '"></span>';
    }
    if (featureSteps) {
      featureSteps.innerHTML = stepsHTML;
    }

    // Display tick icon until the 4th click
    if (clickCount < 5 && tickIcon) {
      tickIcon.style.display = 'inline-block';
    }

    adjustFontSizes(increase, btn, addsize);

    document.addEventListener('DOMContentLoaded', function () {

      var featureItem = document.getElementById('featureItem');
      var featureSteps = document.getElementById('featureSteps');
      var tickIcon = document.getElementById('tickIcon');

      // Get Storage Items
      var ts_ButtonStorageClick = localStorage.getItem(ButtonStorageClick);
      var ts_Storageclick = localStorage.getItem(Storageclick);
      if (ts_ButtonStorageClick && ts_Storageclick) {
        var FontSizeBtnState = JSON.parse(ts_ButtonStorageClick);
        var FontSizeClickState = JSON.parse(ts_Storageclick);
      }
      // var FontSizeState = localStorage.getItem(SizeStorage);
      var FontSizeStateBigger = localStorage.getItem('bt-size');
      var FontSizeStateSmaller = localStorage.getItem('st-size');


      if (FontSizeBtnState) {

        if (featureItem && featureSteps && tickIcon) {
          featureItem.classList.add('feature-active');
          featureSteps.classList.add('featureSteps-visible');
          tickIcon.style.display = 'inline-block';
        }

        // Add step span tags dynamically
        var StoragestepsHTML = '';
        for (var i = 0; i < 4; i++) {
          StoragestepsHTML += '<span class="' + (i < FontSizeClickState ? 'active step uwaw-features__step' : 'step uwaw-features__step') + '"></span>';
        }
        if (featureSteps) {
          featureSteps.innerHTML = StoragestepsHTML;
        }

        if (FontSizeStateBigger !== null && !isNaN(Number(FontSizeStateBigger)) && Number(FontSizeStateBigger) !== 0) {
          const button = document.getElementById('btn-small-text') as HTMLButtonElement | null;
          if (button) {
            button.disabled = true;
          }
          var elements = document.querySelectorAll('*:not(.uw-widget-custom-trigger, .uw-widget-custom-trigger span)');
          elements.forEach(function (element) {
            const htmlElement = element as HTMLElement;
            // Exclude elements inside #uw-main and with class .uwaw-features__item__name
            if (!isExcludedElement(element)) {
              var currentSize = window.getComputedStyle(element).fontSize;
              if (FontSizeStateBigger) {
                var newSize = parseFloat(currentSize) + parseFloat(FontSizeStateBigger);
                htmlElement.style.setProperty('font-size', newSize + 'px', 'important');
              }
            }
          });

        }

        if (FontSizeStateSmaller !== null && parseFloat(FontSizeStateSmaller) !== 0) {
          const btnS9 = document.getElementById('btn-s9') as HTMLButtonElement | null;
          if (btnS9) {
            btnS9.disabled = true;
          }
          var elements = document.querySelectorAll('*:not(.uw-widget-custom-trigger, .uw-widget-custom-trigger span)');
          elements.forEach(function (element) {
            // Exclude elements inside #uw-main and with class .uwaw-features__item__name
            if (!isExcludedElement(element)) {
              var currentSize = window.getComputedStyle(element).fontSize;
              if (FontSizeStateSmaller) {
                var newSize = parseFloat(currentSize) - parseFloat(FontSizeStateSmaller);
                (element as HTMLElement).style.setProperty('font-size', newSize + 'px', 'important');
              }
            }
          });
        }
      }

    });

  }
  function adjustFontSizes(increase: any, btn: string, addsize: string | number) {
    var SizeStorage = btn + '-size';
    var elements = document.querySelectorAll('*:not(.uw-widget-custom-trigger, .uw-widget-custom-trigger span)');
    elements.forEach(function (element) {
      // Exclude elements inside #uw-main and with class .uwaw-features__item__name
      if (!isExcludedElement(element)) {
        var currentSize = window.getComputedStyle(element).fontSize;
        var newSize = increase ? parseFloat(currentSize) + 1 : parseFloat(currentSize) - 1;
        // element.style.fontSize = newSize + 'px';
        (element as HTMLElement).style.setProperty('font-size', newSize + 'px', 'important');
        localStorage.setItem(SizeStorage, addsize.toString());
      }
    });
  }

  function isExcludedElement(element: Element) {
    // Check if the element is inside #uw-main or has class .uwaw-features__item__name
    if (
      element.closest('#uw-main') ||
      element.classList.contains('uwaw-features__item__name') ||
      element.classList.contains('ux4g-text-spacing') ||
      element.classList.contains('feature-image') ||
      element.classList.contains('icon_global') ||
      element.classList.contains('copyright-text') ||
      element.classList.contains('ux4g-copy')
    ) {
      return true;
    }

    // Exclude script and svg elements
    if (element.tagName === 'SCRIPT' || element.tagName === 'DIV' || element.tagName === 'LINK'
      || element.tagName === 'HTML'
      || element.tagName === 'HEAD'
      || element.tagName === 'BODY'
      || (element.tagName === 'svg' && element.namespaceURI === 'http://www.w3.org/2000/svg')) {
      return true;
    }

    return false;
  }
  function resetFontSizes(btn: string, Storageclick: string, ButtonStorageClick: string) {
    var elements = document.querySelectorAll('*');
    elements.forEach(function (element) {
      // Reset font-size style for all elements
      (element as HTMLElement).style.fontSize = '';
      localStorage.setItem('st-size', JSON.stringify(0));
      localStorage.setItem('st-clickCount', JSON.stringify(0));
      localStorage.setItem('st-buttonClicked', JSON.stringify(false));
      localStorage.setItem('bt-size', JSON.stringify(0));
      localStorage.setItem('bt-clickCount', JSON.stringify(0));
      localStorage.setItem('bt-buttonClicked', JSON.stringify(false));
      localStorage.setItem('btn-big', JSON.stringify(false));
      localStorage.setItem('btn-small', JSON.stringify(false));
    });
  }
  // ********************************************** Text Spacing ****************************************************
  // ********************************************** Text Spacing ****************************************************
  function increaseAndReset() {
    let letterSpacing = 0; // Initial letter spacing (auto)
    let clickCountText = 0; // Counter to track button clicks
    var localStorageSpacingCount = localStorage.getItem('ts-clickCount');
    if (localStorageSpacingCount) {
      clickCountText = parseInt(localStorageSpacingCount, 10);
      clickCountText++;
    }
    var featureItem_ts = document.getElementById('featureItem-ts');
    var featureSteps_ts = document.getElementById('featureSteps-ts');
    var tickIcon_ts = document.getElementById('tickIcon-ts');

    // Save current state to local storage
    localStorage.setItem('ts-clickCount', clickCountText.toString());
    localStorage.setItem('ts-buttonClicked', JSON.stringify(true));

    // Reset letter spacing after the third click
    if (clickCountText === 4) {
      letterSpacing = 0; // Reset letter spacing to auto (0)
      clickCountText = 0; // Reset click count
      if (featureItem_ts && featureSteps_ts && tickIcon_ts) {
        featureItem_ts.classList.remove('feature-active');
        featureSteps_ts.classList.remove('featureSteps-visible');
        featureSteps_ts.innerHTML = '';
        tickIcon_ts.style.display = 'none';
      }

      // Save current state to local storage
      localStorage.setItem('ts-clickCount', clickCountText.toString());
      localStorage.setItem('ts-buttonClicked', JSON.stringify(false));

      // Reset font size of all elements
      resetLetterspacing();
      return;
    }

    // Add feature-active class on the first click
    if (clickCountText === 1) {
      if (featureItem_ts && featureSteps_ts) {
        featureItem_ts.classList.add('feature-active');
        featureSteps_ts.classList.add('featureSteps-visible');
      }

      // Save current state to local storage
      localStorage.setItem('ts-clickCount', clickCountText.toString());
      localStorage.setItem('ts-buttonClicked', JSON.stringify(true));
    }

    // Add step span tags dynamically
    var stepsHTML_ts = '';
    for (var i = 0; i < 3; i++) {
      stepsHTML_ts += '<span class="' + (i < clickCountText ? 'active step uwaw-features__step' : 'step uwaw-features__step') + '"></span>';
    }
    if (featureSteps_ts) {
      featureSteps_ts.innerHTML = stepsHTML_ts;
    }
    // Display tick icon until the 4th click
    if (clickCountText < 4) {
      if (tickIcon_ts) {
        tickIcon_ts.style.display = 'inline-block';
      }
    }

    letterSpacing += 0.7; // Increase by 5px
    applyLetterSpacing();
  }
  function resetLetterspacing() {
    var elements = document.querySelectorAll('*:not(.uw-widget-custom-trigger, .uw-widget-custom-trigger span)');
    elements.forEach(function (element) {
      // Reset font-size style for all elements
      (element as HTMLElement).style.letterSpacing = ''; // Reset to default or "normal"
      localStorage.setItem('ts-spacing', JSON.stringify(null));
      localStorage.setItem('ts-clickCount', JSON.stringify(0));
      localStorage.setItem('ts-buttonClicked', JSON.stringify(false));
    });
  }
  function applyLetterSpacing() {
    const elements = document.querySelectorAll('*:not(.uw-widget-custom-trigger, .uw-widget-custom-trigger span)'); // Select all elements except buttons
    elements.forEach(function (element) {
      if (!isExcludedElement(element)) {

        var currentSize_ts = parseFloat(window.getComputedStyle(element).letterSpacing);
        currentSize_ts = isNaN(currentSize_ts) ? 0 : currentSize_ts; // Handle cases where lineHeight is 'normal' or an invalid value

        const increment = 0.7;
        const newSize_ts = currentSize_ts + increment;

        // Update the element's style (string with 'px')
        (element as HTMLElement).style.setProperty('letter-spacing', `${newSize_ts}px`, 'important');

        // Save the numerical value (not including 'px') to localStorage
        localStorage.setItem('ts-spacing', newSize_ts.toString());
      }
    });
  }
// ****************************** Hightlight Links **********************************
// ****************************** Hightlight Links **********************************
function highlightLinks() {
  var tickIcon_ht = document.getElementById('tickIcon-ht');
  var featureItem = document.getElementById('featureItem-ht');
  
  // Toggle the visibility of the tickIcon
  if(tickIcon_ht) {
    tickIcon_ht.style.display = tickIcon_ht.style.display === 'none' ? 'inline-block' : 'none';
  }

  // Toggle the feature-active class on featureItem
  if(featureItem) {
    featureItem.classList.toggle('feature-active');
  }

  // Toggle the highlight of links
  var links = document.querySelectorAll('a');
  var linksHighlighted = false;
  links.forEach(function (link, index) {
    if (!isExcludedElement(link)) {
      link.style.setProperty('background', link.style.background ? '' : 'black', 'important');
      link.style.setProperty('color', link.style.color ? '' : 'yellow', 'important');
      link.style.setProperty('border', link.style.border ? '' : '1px solid yellow', 'important');
      // Check if link is highlighted
      if (link.style.getPropertyValue('background') === 'black' && link.style.getPropertyValue('color') === 'yellow') {
        linksHighlighted = true;
      }
    }
  });

  // Save state in local storage

  // Safely check if 'tickIcon_ht' exists
const tickIconVisible = tickIcon_ht
  ? window.getComputedStyle(tickIcon_ht).display !== 'none'
  : false;

// Ensure 'featureItem' is not null
const featureActive = featureItem
  ? featureItem.classList.contains('feature-active')
  : false;

// Ensure 'linksHighlighted' is defined and has a valid value
const isLinksHighlighted  = linksHighlighted || false; // Adjust default if necessary

// Create the object with the current state
const HighlightLinkState = {
  tickIconVisible,
  featureActive,
  linksHighlighted: isLinksHighlighted,
};

// Store the object as a JSON string in localStorage
localStorage.setItem("highlightLinks", JSON.stringify(HighlightLinkState));

} 
// ************************************** Cursor Logic ******************************************
// ************************************** Cursor Logic ******************************************
function toggleCursorFeature() {
  // Toggle the 'ux4g-bg-cursor' class on the body
  document.documentElement.classList.toggle('ux4g-bg-cursor');

  // Toggle the tick icon
  var tickIcon_cursor = document.getElementById('tickIcon-cursor');
  if(tickIcon_cursor) {
      tickIcon_cursor.style.display = tickIcon_cursor.style.display === 'none' ? 'inline-block' : 'none';
  }

  var featureItem = document.getElementById('featureItem-Cursor');

  // Toggle the feature-active class on featureItem
  if(featureItem) {
      featureItem.classList.toggle('feature-active');
      // Save state in local storage
  localStorage.setItem("cursorFeatureActive", JSON.stringify(featureItem.classList.contains('feature-active')));
  }

}
// ************************************** Hide Images ******************************************
// ************************************** Hide Images ******************************************
function toggleImages() {
    document.documentElement.classList.toggle('image-hide');
    document.documentElement.id = document.documentElement.classList.contains('image-hide') ? 'imageHideBg' : '';
    var images = document.querySelectorAll('img');
    // var bgRemove = document.querySelectorAll('*');
    var imageVisibilityState: {[key: number]: string} = {};
    // var bgimageVisibilityState = {};
    var tickIcon_ht = document.getElementById('tickIcon-hi');
    var featureItem = document.getElementById('featureItem-hi');
  
    // Toggle the visibility of images
    images.forEach(function (image, index) {
        if (!isExcludedElement(image)) {
          image.style.setProperty('visibility', image.style.visibility === 'hidden' ? 'visible' : 'hidden', 'important');
          imageVisibilityState[index] = image.style.visibility;
          
        }
    });  
  
    // Toggle the visibility of the tickIcon
    if(tickIcon_ht){
        tickIcon_ht.style.display = tickIcon_ht.style.display === 'none' ? 'inline-block' : 'none';
    }  
    // Toggle the feature-active class on featureItem
    if(featureItem) {
        featureItem.classList.toggle('feature-active');
    }
  
    localStorage.setItem('imageVisibilityState', JSON.stringify(imageVisibilityState));
  
  }

// ********************************************** Font feature Dyslexia Friendly *****************************************
// ********************************************** Font feature Dyslexia Friendly *****************************************
function toggleFontFeature() {
  
  // Toggle the 'ux4g-font-df' class on the body
  document.documentElement.classList.toggle('ux4g-font-df');

  // Toggle the tick icon
  var tickIcon_df = document.getElementById('tickIcon-df');
  if(tickIcon_df) {
      tickIcon_df.style.display = tickIcon_df.style.display === 'none' ? 'inline-block' : 'none';
  }

  var featureItem = document.getElementById('featureItem-df');

  // Toggle the feature-active class on featureItem
  if(featureItem) {
      featureItem.classList.toggle('feature-active');
  }

  // Save state in local storage
  localStorage.setItem("dyslexia", JSON.stringify(document.documentElement.classList.contains('ux4g-font-df')));

}
// ********************************************** Dark Mode *****************************************
// ********************************************** Dark Mode *****************************************
function darkMode() {
   var tickIcon_ht_dark = document.getElementById('tickIcon-ht-dark');
        var featureItemDrak = document.getElementById('featureItem-ht-dark');
        const checkbox = document.getElementById("checkbox") as HTMLInputElement | null;
    
        if(checkbox) {
          const isDarkMode = checkbox.checked;
          document.body.classList.toggle("dark", isDarkMode);  
      }
    
        // Toggle the visibility of the tickIcon
        if(tickIcon_ht_dark) {
          tickIcon_ht_dark.style.display = tickIcon_ht_dark.style.display === 'none' ? 'inline-block' : 'none';
        }
    
        // Toggle the feature-active class on featureItem
        if(featureItemDrak) {
          featureItemDrak.classList.toggle('feature-active');
        }
    
        // Save the state to local storage
        if(checkbox) {
          const isDarkMode = checkbox.checked;
          localStorage.setItem("darkMode", JSON.stringify(isDarkMode));
        }
}
// ************************************* Invert Colors ************************************
// ************************************* Invert Colors ************************************
function invertColors() {
    
        // Toggle the 'invert' class on the body
        document.documentElement.classList.toggle('ux4g-bg-white');
      
        // Toggle the tick icon
        var tickIcon_ic = document.getElementById('tickIcon-ic');
        if(tickIcon_ic) {
            tickIcon_ic.style.display = tickIcon_ic.style.display === 'none' ? 'inline-block' : 'none';
        }
      
        var featureItem = document.getElementById('featureItem-ic');
      
        // Toggle the feature-active class on featureItem
        if(featureItem) {
            featureItem.classList.toggle('feature-active');
        }
      
        // Save the state in localStorage
        if(document.documentElement.classList.contains('ux4g-bg-white')) {}
        localStorage.setItem('invertFeature', String(document.documentElement.classList.contains('ux4g-bg-white')));
}
// 
// 
function lineHeight() {
  var clickCount_lh = 0;
  
  // Check local storage for previous state
  var localStorageClickCount = localStorage.getItem('lh-clickCount');
  if (localStorageClickCount) {
    clickCount_lh = parseInt(localStorageClickCount, 10);
  }

  clickCount_lh++;
  var featureItem_lh = document.getElementById('featureItem-lh');
  var featureSteps_lh = document.getElementById('featureSteps-lh');
  var tickIcon_lh = document.getElementById('tickIcon-lh');
  
    // Save current state to local storage
    localStorage.setItem('lh-clickCount', clickCount_lh.toString());
    localStorage.setItem('lh-buttonClicked', JSON.stringify(true));
  
  // Reset on 5th click
  if (clickCount_lh === 4) {
    clickCount_lh = 0;
    if(featureItem_lh && featureSteps_lh && tickIcon_lh) {
        featureItem_lh.classList.remove('feature-active');
        featureSteps_lh.classList.remove('featureSteps-visible');
        featureSteps_lh.innerHTML = '';
        tickIcon_lh.style.display = 'none';
    }
    // Reset font size of all elements
  
    // Save current state to local storage
    localStorage.setItem('lh-clickCount', JSON.stringify(0));
    localStorage.setItem('lh-buttonClicked', JSON.stringify(false));
  
    resetlineheight();
    return;
  }
  
  // Add feature-active class on the first click
  if (clickCount_lh === 1) {
    if(featureItem_lh && featureSteps_lh) {
        featureItem_lh.classList.add('feature-active');
        featureSteps_lh.classList.add('featureSteps-visible');
    }
    localStorage.setItem('lh-clickCount', JSON.stringify(1));
    localStorage.setItem('lh-buttonClicked', JSON.stringify(true));
  }
  
  // Update data-uw-reader-content attribute
  const btnElement = document.getElementById('btn-s12');

  // Check if the element is not null before trying to set the attribute
  if (btnElement !== null) {
     btnElement.setAttribute('data-uw-reader-content', clickCount_lh.toString());
  } else {
     console.error('Element with ID "btn-s12" not found');
  }
  // Add step span tags dynamically
  var stepsHTML_lh = '';
  for (var i = 0; i < 3; i++) {
      stepsHTML_lh += '<span class="' + (i < clickCount_lh ? 'active step uwaw-features__step' : 'step uwaw-features__step') + '"></span>';
  }
  if(featureSteps_lh) {
    featureSteps_lh.innerHTML = stepsHTML_lh;
  }
  // Display tick icon until the 4th click
  if (clickCount_lh < 4) {
    if(tickIcon_lh) {
        tickIcon_lh.style.display = 'inline-block';
    }
  }
  
  increaseLineheight();
}
function resetlineheight() {
  var elements = document.querySelectorAll('*');
  elements.forEach(function (element) {
    var elementAsHTMLElement = element as HTMLElement;
  // Reset font-size style for all elements
  elementAsHTMLElement.style.lineHeight = ''; // Reset to default or "normal"
  localStorage.setItem('lh-height', JSON.stringify(null));
  localStorage.setItem('lh-clickCount', JSON.stringify(0));
  localStorage.setItem('lh-buttonClicked', JSON.stringify(false));
  });
  }
  function increaseLineheight() {
    var elements = document.querySelectorAll('*:not(.uw-widget-custom-trigger, .uw-widget-custom-trigger span)');
    elements.forEach(function(element) {
       // Exclude elements inside #uw-main and with class .uwaw-features__item__name
        if (!isExcludedElement(element)) {
            const elementAsHTMLElement = element as HTMLElement;
            var currentSize_lh = parseFloat(window.getComputedStyle(element).lineHeight);
            currentSize_lh = isNaN(currentSize_lh) ? 0 : currentSize_lh; // Handle cases where lineHeight is 'normal' or an invalid value

            // Convert to pixels (optional, depending on your needs)
            var newSize_lh = currentSize_lh + 10;

            // Optionally, convert to pixels if needed
            var newSize_lh_px = newSize_lh + 'px';
            // element.style.lineHeight = newSize_lh;
            elementAsHTMLElement.style.setProperty('line-height', newSize_lh_px, 'important'); /*add er*/

        }
   });
  }
  return (
    <>
      {/* accessibility panel */}
      <div
        className="uwaw uw-light-theme gradient-head uwaw-initial paid_widget" style={{zIndex: '100000', }}
        id="uw-main"
      >
        <div className="relative second-panel">
          <h3>Accessibility options</h3>
          <div className="uwaw-close"
            onClick={closeMain}
          />
        </div>
        <div className="uwaw-body">
          <div className="h-scroll">
            <div className="uwaw-features">
              {/* <div
                className="uwaw-features__item reset-feature"
                id="featureItem_sp"
              >
                <button
                  id="speak"
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                  // onClick={textToSpeak}
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-speaker"> </span>
                  </span>
                  <span className="uwaw-features__item__name">Text To Speech</span>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon_sp"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div> */}
              <div className="uwaw-features__item reset-feature" id="featureItem">
                <button
                  id="btn-s9"
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                  onClick={() => handleFontSizes({
                    btnId: 'btn-s9',
                    featureItemId: 'featureItem',
                    featureStepsId: 'featureSteps',
                    tickIconId: 'tickIcon',
                    increase: true, 
                    btn: 'bt',
                  })}
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-bigger-text"> </span>{" "}
                  </span>
                  <span className="uwaw-features__item__name">Bigger Text</span>
                  <div
                    className="uwaw-features__item__steps reset-steps"
                    id="featureSteps"
                  >
                    {/* Steps span tags will be dynamically added here */}
                  </div>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div>
              {/* <div
                className="uwaw-features__item reset-feature"
                id="featureItem-st"
              >
                <button
                  id="btn-small-text"
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                  onClick={() => handleFontSizes({
                    btnId: 'btn-small-text',
                    featureItemId: 'featureItem-st',
                    featureStepsId: 'featureSteps',
                    tickIconId: 'tickIcon',
                    increase: false,
                    btn: 'st',
                  })}
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-small-text"> </span>{" "}
                  </span>
                  <span className="uwaw-features__item__name">Small Text</span>
                  <div
                    className="uwaw-features__item__steps reset-steps"
                    id="featureSteps-st"
                  >
                    
                  </div>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-st"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div> */}
              <div
                className="uwaw-features__item reset-feature"
                id="featureItem-lh"
              >
                <button
                  id="btn-s12"
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                  onClick={lineHeight}
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-line-hight"> </span>
                  </span>
                  <span className="uwaw-features__item__name">Line Height</span>
                  <div
                    className="uwaw-features__item__steps reset-steps"
                    id="featureSteps-lh"
                  >
                    {/* Steps span tags will be dynamically added here */}
                  </div>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-lh"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div>
              <div
                className="uwaw-features__item reset-feature"
                id="featureItem-ht"
              >
                <button
                  id="btn-s10"
                  onClick={highlightLinks}
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-highlight-links"> </span>
                  </span>
                  <span className="uwaw-features__item__name">Highlight Links</span>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-ht"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div>
              <div
                className="uwaw-features__item reset-feature"
                id="featureItem-ts"
              >
                <button
                  id="btn-s13"
                  onClick={increaseAndReset}
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-text-spacing"> </span>
                  </span>
                  <span className="uwaw-features__item__name">Text Spacing</span>
                  <div
                    className="uwaw-features__item__steps reset-steps"
                    id="featureSteps-ts"
                  >
                    {/* Steps span tags will be dynamically added here */}
                  </div>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-ts"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div>
              <div
                className="uwaw-features__item reset-feature"
                id="featureItem-df"
              >
                <button
                  id="btn-df"
                  onClick={toggleFontFeature}
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-dyslexia-font"> </span>
                  </span>
                  <span className="uwaw-features__item__name">
                    Dyslexia Friendly
                  </span>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-df"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div>
              <div
                className="uwaw-features__item reset-feature"
                id="featureItem-hi"
              >
                <button
                  id="btn-s11"
                  onClick={toggleImages}
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-hide-images"> </span>
                  </span>
                  <span className="uwaw-features__item__name">Hide Images</span>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-hi"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div>
              <div
                className="uwaw-features__item reset-feature"
                id="featureItem-Cursor"
              >
                <button
                  id="btn-cursor"
                  onClick={toggleCursorFeature}
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-cursor"> </span>
                  </span>
                  <span className="uwaw-features__item__name">Cursor</span>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-cursor"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div>
              <div
                className="uwaw-features__item reset-feature"
                id="featureItem-ht-dark"
              >
                <button
                  id="dark-btn"
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                  onClick={darkMode}
                >
                  <span className="uwaw-features__item__name">
                    <span className="light_dark_icon">
                      <input
                        type="checkbox"
                        className="light_mode uwaw-featugres__item__i"
                        id="checkbox"
                      />
                      <label htmlFor="checkbox" className="checkbox-label">
                        {/* <i class="fas fa-moon-stars"></i> */}
                        <i className="fas fa-moon-stars">
                          <span className="ux4g-icon icon-moon" />
                        </i>
                        <i className="fas fa-sun">
                          <span className="ux4g-icon icon-sun" />
                        </i>
                        <span className="ball" />
                      </label>
                    </span>
                    <span className="uwaw-features__item__name">Light-Dark</span>
                  </span>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-ht-dark"
                    style={{ display: "none", pointerEvents: "none" }}
                  ></span>
                </button>
              </div>
              {/* Invert Colors Widget */}
              <div
                className="uwaw-features__item reset-feature"
                id="featureItem-ic"
              >
                <button
                  id="btn-invert"
                  className="uwaw-features__item__i"
                  data-uw-reader-content="Enable the UserWay screen reader"
                  aria-label="Enable the UserWay screen reader"
                  aria-pressed="false"
                  onClick={invertColors}
                >
                  <span className="uwaw-features__item__icon">
                    <span className="ux4g-icon icon-invert"> </span>
                  </span>
                  <span className="uwaw-features__item__name">Invert Colors</span>
                  <span
                    className="tick-active uwaw-features__item__enabled reset-tick"
                    id="tickIcon-ic"
                    style={{ display: "none" }}
                  ></span>
                </button>
              </div>
            </div>
          </div>
          {/* Reset Button */}
        </div>
        <div className="reset-panel">
          {/* copyright accessibility bar */}
          <div className="copyrights-accessibility">
            <button className="btn-reset-all" id="reset-all"
            // onClick={resetAll}
            >
              <span className="reset-icon"> </span>
              <span className="reset-btn-text">Reset All Settings</span>
            </button>
            <a
              href="https://www.ux4g.gov.in"
              target="_blank"
              className="copyright-text"
              contentEditable="false"
              style={{ cursor: "pointer" }}
            >
              <span className="uwaw-features__item__name ux4g-copy ux4g-copyright">
                Created by
              </span>
              <img
                src="https://www.ux4g.gov.in/assets/img/logo/ux4g-logo.svg"
                alt="logo"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </div>
      <button
        id="uw-widget-custom-trigger"
        className="uw-widget-custom-trigger"
        aria-label="Accessibility Widget"
        data-uw-trigger="true"
        aria-haspopup="dialog"
      >
        <img alt="Accessibility Options" src="data:image/svg+xml,%0A%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_1_1506)'%3E%3Cpath d='M16 7C15.3078 7 14.6311 6.79473 14.0555 6.41015C13.4799 6.02556 13.0313 5.47894 12.7664 4.83939C12.5015 4.19985 12.4322 3.49612 12.5673 2.81719C12.7023 2.13825 13.0356 1.51461 13.5251 1.02513C14.0146 0.535644 14.6383 0.202301 15.3172 0.0672531C15.9961 -0.0677952 16.6999 0.00151652 17.3394 0.266423C17.9789 0.53133 18.5256 0.979934 18.9101 1.55551C19.2947 2.13108 19.5 2.80777 19.5 3.5C19.499 4.42796 19.1299 5.31762 18.4738 5.97378C17.8176 6.62994 16.928 6.99901 16 7Z' fill='white'/%3E%3Cpath d='M27 7.05L26.9719 7.0575L26.9456 7.06563C26.8831 7.08313 26.8206 7.10188 26.7581 7.12125C25.595 7.4625 19.95 9.05375 15.9731 9.05375C12.2775 9.05375 7.14313 7.67875 5.50063 7.21188C5.33716 7.14867 5.17022 7.09483 5.00063 7.05063C3.81313 6.73813 3.00063 7.94438 3.00063 9.04688C3.00063 10.1388 3.98188 10.6588 4.9725 11.0319V11.0494L10.9238 12.9081C11.5319 13.1413 11.6944 13.3794 11.7738 13.5856C12.0319 14.2475 11.8256 15.5581 11.7525 16.0156L11.39 18.8281L9.37813 29.84C9.37188 29.87 9.36625 29.9006 9.36125 29.9319L9.34688 30.0112C9.20188 31.0206 9.94313 32 11.3469 32C12.5719 32 13.1125 31.1544 13.3469 30.0037C13.5813 28.8531 15.0969 20.1556 15.9719 20.1556C16.8469 20.1556 18.6494 30.0037 18.6494 30.0037C18.8838 31.1544 19.4244 32 20.6494 32C22.0569 32 22.7981 31.0162 22.6494 30.0037C22.6363 29.9175 22.6206 29.8325 22.6019 29.75L20.5625 18.8294L20.2006 16.0169C19.9387 14.3788 20.1494 13.8375 20.2206 13.7106C20.2225 13.7076 20.2242 13.7045 20.2256 13.7013C20.2931 13.5763 20.6006 13.2963 21.3181 13.0269L26.8981 11.0763C26.9324 11.0671 26.9662 11.0563 26.9994 11.0438C27.9994 10.6688 28.9994 10.15 28.9994 9.04813C28.9994 7.94625 28.1875 6.73813 27 7.05Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1_1506'%3E%3Crect width='32' height='32' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A" />
        <span>Accessibility Options</span>
      </button>
      {/* accessibility panel end*/}
    </>
  );
}

export default Accessibility;

